import { TeamMember } from "../types/TeamMember"
import { TeamRole } from "../types/TeamRole"

export const TEAM_ROLE_PRIORITY: Record<TeamRole, number> = {
  [TeamRole.ADMIN]: 3,
  [TeamRole.WRITE]: 2,
  [TeamRole.READ]: 1
}

export function sortTeamMembers(
  members: TeamMember[],
  currentUserMember: TeamMember | null
): TeamMember[] {
  return members
    .map(member => ({
      ...member,
      isCurrentUser: member.user?.id === currentUserMember?.user?.id
    }))
    .sort((a, b) => {
      if (a.isCurrentUser && !b.isCurrentUser) return -1
      if (!a.isCurrentUser && b.isCurrentUser) return 1
      if (a.role && b.role) {
        return (
          (TEAM_ROLE_PRIORITY[b.role as TeamRole] ?? 0) -
          (TEAM_ROLE_PRIORITY[a.role as TeamRole] ?? 0)
        )
      }
      return 0
    })
}
